var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payment-template',{class:{ 'promotion': _vm.usePromotionTemplate }},[(_vm.isAmountLoaded)?_c('card-recharge',{attrs:{"order":_vm.order,"amount":_vm.amount,"period":_vm.period,"monthly-cost":_vm.monthlyCost,"show-months":_vm.canShowMonths,"emergency-credit":_vm.isEmergencyCredit},on:{"recharged":_vm.onRecharged}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }